export default{
  banner: {
    titleImg: '',
    video:{
      src: '',
      poster: '',
      title: '',
      dec: ''
    }
  },
  cards:[
   
    {
      title: '黑谷能为你做什么',
      content: '黑谷为门店全方位打造成共享店铺提供专业的共享系统、整套策划方案和执行方案以及专家团队执行落地。为门店的共享合作系统化、标准化、流程化，实现系统自动计算合作人奖励，可及时查看收益，短期快速将共享店铺执行落地'
    },
    {
      title: '黑谷落地执行方案',
      list: [
        '专业定制门店的共享方案，让合作人出钱、出力、出心',
        '提供合作人贡献客源方案，迅速增长新客',
        '如何签订规避法律风险的共享协议',
        '如何巧妙的将门店闲置工位、员工、资源打造共享',
        '设计合作人激励的现金模式',
        '如何准确、快速找到适合你的合作人对象'
      ]
    }
  ],
  experts:{
    title: '共享店铺专家团队',
    dec: '顾问式服务，现场面对面分析解决门店难题',
    teams: [
      {
        avatar: require('../images/shop/experts/01.jpg'),
        name: '李全发',
        tag: '黑谷创始人',
        intro: '传统行业出身，原计算机专业，他曾开3家汽修连锁门店。有10年以上的风险管理经验；独创共享股权9步法。擅长股权设计、商业模式创新'
      },
      {
        avatar: require('../images/shop/experts/02.jpg'),
        name: '蔡桐才',
        tag: '黑谷特聘顾问',
        intro: '原路畅科技副总裁，固特异轮胎大中华区营销总监。国内著名汽车服务培训专家，35年行业工作经验。深谙汽车行业门店经营管理之道以及行业发展趋势。'
      },
      {
        avatar: require('../images/shop/experts/03.jpg'),
        name: '苏桔良',
        tag: '黑谷特聘顾问',
        intro: '屈阁华刚控股集团副总裁，优一步汽车网络商学院创始人。中国汽车维修行业协会互联网专家。擅长门店经营盈利提升运作与行业培训指导。'
      },
      {
        avatar: require('../images/shop/experts/04.jpg'),
        name: '温莲英',
        tag: '云南德胜创始人',
        intro: '云南建水县城400平方小店，用一年多的时间让营业额从15万增长到100多万，创造了一个行业神话！'
      },
      {
        avatar: require('../images/shop/experts/05.jpg'),
        name: '陈明',
        tag: '厦门鹭畅行创始人',
        intro: '仅用2年从修车工到6000平方维修厂的90后“网红”老板！目前在厦门拥有2家连锁门店！'
      },
      {
        avatar: require('../images/shop/experts/06.jpg'),
        name: '蔺如',
        tag: '北京致宝行创始人',
        intro: '一家有意思又很讲究的高端车售后服务公司，员工积极主动拉新，优质服务待客，短短3个月带来3倍客源增长！'
      }
    ]
  }
  
}